





























import Vue, { PropType } from 'vue'
import UiInstallationGuidesHorizontal from './UiInstallationGuidesHorizontal.vue'
import UiInstallationGuidesVertical from './UiInstallationGuidesVertical.vue'
import { Guide } from './UiInstallationGuides.types'

export default Vue.extend({
  name: 'UiInstallationGuides',
  components: {
    UiInstallationGuidesHorizontal,
    UiInstallationGuidesVertical
  },
  props: {
    content: {
      type: Array as PropType<Guide[]>,
      required: true
    },
    layout: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleDownload (title: string): void {
      this.$gtm && this.$gtm.push({
        event: 'user action',
        gaEventCategory: 'download',
        gaEventAction: title, // PDF Title
        gaEventLabel: this.$route.path, // PagePath
        gaEventValue: '5' // Fest =  5
      })
    }
  }
})
